module.exports = __webpack_public_path__ + "img/logoBlue.c36ef846.png";